<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Projekt {{this.data[0].display_Name}} archivieren</h4>
        <!-- <h4>{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}</h4> -->
    </div>

    <div class="card-body">
        <form [formGroup]="archiveProjectForm">
            <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="id" readonly>
            </mat-form-field>
            <!-- <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="legacyId" readonly>
            </mat-form-field> -->
            <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="url" readonly>
            </mat-form-field>
    
            <div class="row">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Begründung" formControlName="comment" required>
                    <!-- <input matInput placeholder="{{this.translate.data['INPUTCOMMENT'] | translate}}" formControlName="comment" required> -->
                </mat-form-field>
            </div>

            <div class="row">
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Abbruch</button>
                </a>                                                
                <span style="flex: 1 1 auto"></span>
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPARCHIVEPROJECT'] | translate}}"
                                    (click)="archiveProject()" [disabled]="!isFormValid()">Archivieren</button>
                </a>                   
            </div>    

    <!-- <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Dialog schließen"
                (click)="cancel()" >Abbruch</button>
            <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="createCloneProject()" color="primary">Kopieren</button> -->
        </form>
    </div>
</div>